import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Search, RefreshCw } from 'lucide-react';

export const SubscribersFilters = ({
  searchQuery,
  setSearchQuery,
  filterGrade,
  setFilterGrade,
  filterStatus,
  setFilterStatus,
  onRefresh
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 p-4 bg-slate-50 rounded-xl">
      <div className="flex-1 relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <Input
          placeholder="Search by name, ID, or email..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10"
          data-testid="search-input"
        />
      </div>
      
      <Select value={filterGrade} onValueChange={setFilterGrade}>
        <SelectTrigger className="w-[150px]" data-testid="grade-filter">
          <SelectValue placeholder="All Grades" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Grades</SelectItem>
          <SelectItem value="5">Grade 5</SelectItem>
          <SelectItem value="6">Grade 6</SelectItem>
          <SelectItem value="7">Grade 7</SelectItem>
          <SelectItem value="8">Grade 8</SelectItem>
        </SelectContent>
      </Select>
      
      <Select value={filterStatus} onValueChange={setFilterStatus}>
        <SelectTrigger className="w-[150px]" data-testid="status-filter">
          <SelectValue placeholder="All Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Status</SelectItem>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>
      
      <Button
        variant="outline"
        size="icon"
        onClick={onRefresh}
        data-testid="refresh-btn"
      >
        <RefreshCw className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default SubscribersFilters;
